import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <div className="product-detail__images">
          <div className="product-detail__main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
          <div className="product-detail__thumbnails">
            {product.images.map((img, idx) => (
              <button
                key={idx}
                className={`product-detail__thumbnail ${
                  selectedImage === idx ? "active" : ""
                }`}
                onClick={() => setImage(idx)}
              >
                <img src={img} alt={`View ${idx + 1}`} />
              </button>
            ))}
          </div>
        </div>

        <div className="product-detail__info">
          <div className="product-detail__breadcrumb">
            <span>Collection</span>
            <span>→</span>
            <span>{product.category}</span>
          </div>

          <h1 className="product-detail__title">{product.name}</h1>

          <div className="product-detail__price">
            <span className="product-detail__price-current">
              €{product.price}
            </span>
          </div>

          <div className="product-detail__rating">
            <span>
              Review all available options before adding this item to your cart.
            </span>
          </div>

          <div className="product-detail__section">
            <h3 className="product-detail__section-title">CHOOSE YOUR METAL</h3>
            <div className="product-detail__options">
              {product.colors.map((color, idx) => (
                <button
                  key={idx}
                  className={`product-detail__option ${
                    selectedColor === color ? "active" : ""
                  }`}
                  onClick={() => setSelectedColor(color)}
                >
                  <span className="product-detail__option-circle"></span>
                  <span className="product-detail__option-name">{color}</span>
                  <span className="product-detail__option-price">
                    €{product.price}
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="product-detail__section">
            <h3 className="product-detail__section-title">SIZE</h3>
            <select
              value={selectedSize}
              onChange={(event) => setSelectedSize(event.target.value)}
            >
              {product.size.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>

          <button
            className="product-detail__add-to-cart"
            onClick={handleAddToCart}
          >
            Add to Cart
          </button>
        </div>
      </div>

      <div className="product-detail__details-section">
        <h2 className="product-detail__details-title">
          DESCRIPTION &amp; DETAILS
        </h2>
        <div className="product-detail__details-content">
          <div className="product-detail__description">
            {product.description.slice(0, 3).map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          <div className="product-detail__specs">
            <div className="product-detail__spec">
              <span className="product-detail__spec-label">Category:</span>
              <span className="product-detail__spec-value">
                {product.category}
              </span>
            </div>
            <div className="product-detail__spec">
              <span className="product-detail__spec-label">Material:</span>
              <span className="product-detail__spec-value">
                {product.material}
              </span>
            </div>
            <div className="product-detail__spec">
              <span className="product-detail__spec-label">Item:</span>
              <span className="product-detail__spec-value">
                JSK-{String(product.id).padStart(4, "0")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
